export function isIosDevice() {
    return navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad');
}

export function isIos8Safari() {
    return isIosDevice() && navigator.userAgent.includes('Safari') && navigator.userAgent.includes('8.0');
}

/**
 * Returns whether the passed string represents a Safari
 * user agent string. This method does not match the other methods'
 * signatures in order to improve testability. Regex borrowed from
 * https://github.com/ua-parser/uap-core/
 * @param {string} userAgentString The user agent string of interest
 * @return {boolean} true if Safari, false otherwise
 */
export function isSafari(userAgentString) {
    return (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari/).test(userAgentString);
}

/**
 * Desktop Safari uses a BFCache which maintains executed js in memory when a
 * user navigates away from the page, when returning to the page via back/forward
 * the user is hopefully returned to the state they were in previously. This
 * functionality conflicts with our app.
 */
export const disableBFCache = (() => {
    const iPhone = navigator.userAgent.includes('iPhone');
    const iPad = navigator.userAgent.includes('iPad');
    const safari = navigator.userAgent.includes('Safari');

    if (!iPhone && !iPad && safari) {
        window.onpageshow = (event) => {
            if (event.persisted) {
                window.dontPopState = true;
                window.location.reload();
            }
        };
    }
})();

export function bindOnPopStateEvent(modalInstance, onpopstate) {
    const isNotPWAModal = _.get(modalInstance, 'feature', '') !== 'pwa';

    if (isNotPWAModal) {
        if (document.readyState !== 'complete') {
            // load event has not fired
            window.addEventListener('load', () => {
                setTimeout(() => {
                    window.addEventListener('popstate', onpopstate.bind(modalInstance), false);
                }, 0);
            }, false);
        } else {
            // load event has fired
            window.addEventListener('popstate', onpopstate.bind(modalInstance), false);
        }
    }
}
